var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar",class:_vm.curveClass,style:(_vm.barVars)},[_vm._t("left-content",function(){return [_c('div',{staticClass:"spacer"})]}),_vm._t("center-content",function(){return [_c('div',{staticClass:"spacer"})]}),_vm._t("right-content",function(){return [_c('div',{staticClass:"spacer"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }